import { render, staticRenderFns } from "./MyChecks.vue?vue&type=template&id=ab920420&"
import script from "./MyChecks.vue?vue&type=script&lang=js&"
export * from "./MyChecks.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports